import { startTransition, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { isNetworkError } from "@/lib/offline";
import { useAuth, SYNC_KEY } from "@/context/AuthContext";

const ROLE_LABEL = { customer: "perfil alumno", business: "perfil Maestro", super_admin: "Panel Admin" };
const HOME = { customer: "/explorar", business: "/maestro", super_admin: "/admin" };

// Mantiene igual la cuenta en la web y la app abiertas: mismo perfil y cierre de sesión en todas.
export function AccountSync() {
  const { user, setUser, signOutLocal } = useAuth();
  const navigate = useNavigate();
  const role = user?.role;
  const roleRef = useRef(role);
  roleRef.current = role;
  const active = !!user && !user.offline;

  useEffect(() => {
    if (!active) return undefined;
    let busy = false;
    const check = async () => {
      if (busy || document.visibilityState !== "visible" || !navigator.onLine) return;
      busy = true;
      try {
        const { data } = await api.get("/auth/me", { offlineFallback: true });
        if (data.role !== roleRef.current) {
          // Navegar primero y luego actualizar el usuario en transición (como useSwitchRole),
          // si no ProtectedRoute de la ruta actual redirige a "/" antes de llegar al HOME.
          navigate(HOME[data.role] || "/");
          startTransition(() => setUser(data));
          toast.info(`Cambiaste a tu ${ROLE_LABEL[data.role] || "otro perfil"} desde otra ventana o dispositivo`);
        }
      } catch (e) {
        if (!isNetworkError(e) && e.response?.status === 401) {
          navigate("/");
          startTransition(() => signOutLocal());
          toast.info("Cerraste sesión en otra ventana o dispositivo");
        }
      } finally { busy = false; }
    };
    const onStorage = (e) => { if (e.key === SYNC_KEY) check(); };
    const t = setInterval(check, 10000);
    window.addEventListener("storage", onStorage);
    window.addEventListener("focus", check);
    document.addEventListener("visibilitychange", check);
    return () => {
      clearInterval(t);
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("focus", check);
      document.removeEventListener("visibilitychange", check);
    };
  }, [active, setUser, signOutLocal, navigate]);
  return null;
}
